export default __webpack_public_path__ + "static/Main-image-db9a9e3190e563057912b22152c69bc4.png";